import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldSchemesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-schemes-delete',
	path: '/secure/admin/ViewDeleteFieldScreenScheme.jspa',
};
